'use client';

import { usePathname } from 'next/navigation';

import { useIsWebview } from '@flipster/features/src/shared/webview';

import { PromotionContext } from '@web/app/_layout/navigation/promotion';

import { AlertBanner } from './alert-banner';
import Gnb from './gnb';
import type { GnbPromotionItemFragment } from './query.generated';
import { UserLanguageRedirect } from './user-language-redirect';

export const Navigation = ({ promotion }: { promotion?: GnbPromotionItemFragment }) => {
  const pathname = usePathname();
  const isWebview = useIsWebview();

  const isHidePath = ['/maintenance', '/fullchart'].some((path) => pathname.includes(path));

  if (isWebview || isHidePath) return null;
  return (
    <>
      <PromotionContext value={promotion}>
        <Gnb />
      </PromotionContext>
      <AlertBanner />
      <UserLanguageRedirect />
    </>
  );
};
